/**
 * Entry screen. Participants get in by email link or PIN; staff by password.
 * There is no sign-up: accounts exist because an admin created them.
 */

import { apiPost, ApiError } from '../js/api.js'
import { text } from '../js/html.js'

const MODES = {
  link: { label: 'Email link', action: 'Send the link' },
  pin: { label: 'PIN', action: 'Sign in' },
  password: { label: 'Password', action: 'Sign in' },
}

export function renderLogin(root, { onSignedIn }) {
  let mode = 'link'
  let busy = false
  let message = null
  let messageKind = 'info'

  function draw() {
    const { action } = MODES[mode]
    const otherModes = Object.entries(MODES).filter(([key]) => key !== mode)

    root.innerHTML = `
      <h1 class="hero-title">Differ LX</h1>
      <p class="lede">Prijavi se adresom koju si dao pri uplati.</p>

      <form class="card" id="login-form" novalidate>
        <label class="field">
          <span class="field__label">Email</span>
          <input class="field__input" type="email" name="email" autocomplete="email"
                 inputmode="email" required />
        </label>

        ${mode === 'pin' ? `
          <label class="field">
            <span class="field__label">PIN</span>
            <input class="field__input" type="text" name="pin" inputmode="numeric"
                   autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" required />
          </label>
        ` : ''}

        ${mode === 'password' ? `
          <label class="field">
            <span class="field__label">Lozinka</span>
            <input class="field__input" type="password" name="password"
                   autocomplete="current-password" required />
          </label>
        ` : ''}

        <button class="button button--primary" type="submit" ${busy ? 'disabled' : ''}>
          ${busy ? 'Wait…' : action}
        </button>

        ${message ? `<p class="notice notice--${messageKind}">${text(message)}</p>` : ''}
      </form>

      <p class="switcher">
        ${otherModes.map(([key, { label }]) =>
          `<button type="button" class="link-button" data-mode="${key}">${label}</button>`
        ).join('<span class="switcher__sep">·</span>')}
      </p>
    `

    root.querySelectorAll('[data-mode]').forEach((button) => {
      button.addEventListener('click', () => {
        mode = button.dataset.mode
        message = null
        draw()
      })
    })

    root.querySelector('#login-form').addEventListener('submit', submit)
  }

  async function submit(event) {
    event.preventDefault()

    if (busy) return

    const data = new FormData(event.target)
    const email = String(data.get('email') ?? '').trim()

    busy = true
    message = null
    draw()

    try {
      if (mode === 'link') {
        const result = await apiPost('/auth/magic-link', { email })
        messageKind = 'info'
        message = result.message
      } else if (mode === 'pin') {
        const result = await apiPost('/auth/pin', { email, pin: String(data.get('pin') ?? '') })
        onSignedIn(result)
        return
      } else {
        const result = await apiPost('/auth/login', {
          email,
          password: String(data.get('password') ?? ''),
        })
        onSignedIn(result)
        return
      }
    } catch (error) {
      messageKind = 'error'
      message = error instanceof ApiError ? error.message : 'Something went wrong.'
    } finally {
      busy = false
      draw()
    }
  }

  draw()
}
